module.exports = __webpack_public_path__ + "assets/acd319ce358fb226a6acacb4a3332aad.svg";